<template>
  <div :id="componentId" class="sp1-highlights-grid" :style="gridStyle">
    <div class="sp1-group_70 flex-row">
      <div
        v-for="(item, idx) in items"
        :key="idx"
        :class="[outerClass(idx), 'flex-col', 'align-center', { 'is-link': item.jumpType === 2 }]"
        @click="handleClick(item)"
      >
        <div :class="cardClass(idx)" :style="{ backgroundImage: `url(${item.backgroundImage})` }">
          <span :class="titleClass(idx)">{{ item.title }}</span>
          <div class="sp1-box_5 flex-col" :style="{ backgroundColor: item.boxBackgroundColor }"></div>
          <span :class="contentClass(idx)">{{ item.content }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HighlightsGrid',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_5'
    }
  },
  data() {
    return {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      items: [
        {
          title: '第七届中国品牌发展论坛',
          content: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行',
          jumpType: 1,
          linkAddress: '',
          backgroundImage: require('../assets/img/FigmaDDSSlicePNG0d648939a8b66653ee5d7d755d4f2a23.png'),
          boxBackgroundColor: 'rgba(43, 131, 120, 1)'
        },
        {
          title: '区域农业品牌年度盛典',
          content: '聚焦区域农业品牌高质量发展，搭建品牌交流与合作平台',
          jumpType: 2,
          linkAddress: 'https://www.example.com/highlight/2',
          backgroundImage: require('../assets/img/FigmaDDSSlicePNG0d648939a8b66653ee5d7d755d4f2a23.png'),
          boxBackgroundColor: 'rgba(43, 131, 120, 1)'
        },
        {
          title: '品牌发展报告发布',
          content: '发布年度区域农业品牌发展报告，解读品牌影响力指数',
          jumpType: 1,
          linkAddress: '',
          backgroundImage: require('../assets/img/FigmaDDSSlicePNG0d648939a8b66653ee5d7d755d4f2a23.png'),
          boxBackgroundColor: 'rgba(43, 131, 120, 1)'
        },
        {
          title: '年度案例权威推荐',
          content: '精选年度区域农业品牌典型案例，分享品牌建设成功经验',
          jumpType: 2,
          linkAddress: 'https://www.example.com/highlight/4',
          backgroundImage: require('../assets/img/FigmaDDSSlicePNG0d648939a8b66653ee5d7d755d4f2a23.png'),
          boxBackgroundColor: 'rgba(43, 131, 120, 1)'
        }
      ]
    };
  },
  computed: {
    gridStyle() {
      return {
        backgroundColor: this.backgroundColor,
        width: '2000px',
        marginLeft: '-300px',
        boxSizing: 'border-box'
      };
    },
    titleGroupStyle() {
      return {
        margin: '0px auto 0',
        width: '360px',
        height: '70px',
        backgroundImage: `url(${this.titleBackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
    }
  },
  methods: {
    handleClick(item) {
      if (item.jumpType !== 2 || !item.linkAddress) return;
      window.open(item.linkAddress, '_blank');
    },
    outerClass(idx) {
      const map = ['sp1-group_4', 'sp1-group_6', 'sp1-group_7', 'sp1-group_8'];
      return map[idx];
    },
    cardClass(idx) {
      const map = ['sp1-group_5', 'sp1-box_6', 'sp1-section_3', 'sp1-section_4'];
      return map[idx] + ' flex-col';
    },
    boxClass(idx) {
      const map = ['sp1-box_5', 'sp1-box_7', 'sp1-box_8', 'sp1-box_9'];
      return map[idx] + ' flex-col';
    },
    titleClass(idx) {
      const map = ['sp1-text_10', 'sp1-text_12', 'sp1-text_14', 'sp1-text_16'];
      return map[idx];
    },
    contentClass(idx) {
      const map = ['sp1-text_11', 'sp1-text_13', 'sp1-text_15', 'sp1-text_17'];
      return map[idx];
    }
  }
};
</script>

<style scoped>
.sp1-highlights-grid {
  width: 2000px;
  margin-left: -300px;
  padding: 0 300px;
  box-sizing: border-box;
  padding-top: 20px;
  padding-bottom: 20px;
}

.sp1-group_69 .sp1-text_9 {
  margin: 0;
  width: auto;
  height: auto;
  text-align: center;
  line-height: 1;
}

.is-link {
  cursor: pointer;
}

.is-link:hover {
  opacity: 0.9;
}
</style>
